import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import VinWonder from '../models/VinWonder';

export function getVinWonders(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_LIST,
        params: params,
        parser: vinWondersDataParser,
    }).get();
}

export function checkVinWonder(serialNumber) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_CHECK,
        endpointParams: { serialNumber }
    }).get();
}

export function getVinWonderDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_DETAIL,
        endpointParams: { id },
        parser: data => new VinWonder(data.data),
    }).get();
}

export function createVinWonder(vinWonder) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_CREATE,
    }).post(vinWonder.export());
}

export function updateVinWonder(vinWonder) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_UPDATE,
    }).put(vinWonder.export());
}

export function deleteVinWonder(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_DELETE,
        endpointParams: { id },
    }).delete();
}

export function createVinWonderTranslate(vinWonder) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TRANSLATE_CREATE,
    }).post(vinWonder.export(true).translate());
}

export function updateVinWonderTranslate(vinWonder) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TRANSLATE_UPDATE,
    }).put(vinWonder.export(true).translate());
}

export function deleteVinWonderTranslate(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getVinWonderSites() {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_SITES
    }).get();
}

export function getVinWonderTypes() {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TYPES
    }).get();
}

export function getVinWonderSessions(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.VIN_WONDER_SESSIONS,
        params: params
    }).get();
}

export function getVinWonderZones(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.VIN_WONDER_ZONES,
        params: params
    }).get();
}

function vinWondersDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new VinWonder(item))
    }
}